const key = "add-clear-properties";

const applicable = (resp) => {
	return resp.config.method === "GET" && resp.config.url.match(/api\/forms\/66$/);
};

const modify = (resp) => {
	const afterField = resp.data.Data.Fields[3]; //#anglers
	const bothField = resp.data.Data.Fields[15]; //hours fished
	const beforeField = resp.data.Data.Fields[9]; //locale

	if(afterField !== undefined) {
		afterField.Clear = "after";
	}
	
	if(beforeField !== undefined) {
		beforeField.Clear = "before";
	}

	if(bothField !== undefined) {
		bothField.Clear = "both";
	}

	// console.log("modified fields", resp.data.Data.Fields);
	return resp;
};

export const addClearProperties = [key, applicable, modify];